import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path: 'additional-links',

  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const AdditionalLinksContainer = require('./containers/AdditionalLinksContainer').default
      const additionalLinksReducer = require('./modules/additionalLinks').default

      injectReducer(store, {
        key: 'additionalLinks',
        reducer: additionalLinksReducer
      })

      cb(null, AdditionalLinksContainer)
    }, 'additionalLinks')
  }
})



// WEBPACK FOOTER //
// ./src/routes/AdditionalLinks/index.js